import React from 'react';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { any, bool, func, string } from 'prop-types';
import './index.scss';
import CustomQuantity from '../../prescription-2/DrugDosageDescription/CustomQuantity';
import { LazyLoadImage } from 'react-lazy-load-image-component';

class DropdownSelection extends React.Component {
  state = {
    expanded: null,
    localDrug: {
      localBrand: this.props.drugIds.brandId,
      localForm: this.props.drugIds.formId,
      localDosage: this.props.drugIds.dosageId,
      localQuantity: this.props.drugIds.quantityId
    },
    customQuantity: this.props.customQuantity
  };

  handleChange = panel => {
    this.setState({
      expanded: this.state.expanded !== panel ? panel : false
    });
  };

  renderBrands(brands) {
    if (brands && brands.length > 0) {
      return brands.map((item, key) => (
        <label
          key={key}
          className={`sc-form__radio ${
            key === this.state.localDrug.localBrand && 'selected'
          }`}
          onClick={event => this.handleBrandUpdate(event, item.brand, key)}
        >
          <input
            name="BrandOrGenericDrug"
            type="radio"
            defaultValue="Lipitor"
            className="sc-form__radio--input sc-form__rx-type"
            onClick={event => this.handleBrandUpdate(event, item.brand, key)}
          />
          <span className="sc-form__radio--check hidden" />
          <span className="sc-form__radio--label">{item.brand}</span>
          <span className="sc-form__radio--borg">
            {item?.drugType
              ? item?.drugType
              : item.isGeneric
              ? '(generic)'
              : '(brand)'}
          </span>
        </label>
      ));
    } else return [];
  }

  handleBrandUpdate = (event, selectedBrand, key) => {
    let newFormId, newDosageId, newQuantityId;
    const { localBrand, localForm, localDosage, localQuantity } =
      this.state.localDrug;
    let { form, dosage, displayQuantity } =
      this.props.brandTypes[localBrand].formTypes[localForm].dosage[localDosage]
        .quantities[localQuantity];
    event.stopPropagation();
    newFormId = _.findConsolidatedFormIndex(
      this.props.brandTypes[key].formTypes,
      form
    );

    newDosageId = _.findConsolidatedDosageIndex(
      this.props.brandTypes[key].formTypes[newFormId].dosage,
      dosage
    );
    newQuantityId = _.findConsolidatedQuantityIndex(
      this.props.brandTypes[key].formTypes[newFormId].dosage[newDosageId]
        .quantities,
      displayQuantity
    );

    let isCustomQtyValid = false;
    if (!_.isEmpty(this.state.customQuantity))
      isCustomQtyValid = _.checkIfCustomQtyVisible(
        this.props.brandTypes[key].formTypes[newFormId].name
      );

    this.setState({
      localDrug: {
        localBrand: key,
        localForm: newFormId,
        localDosage: newDosageId,
        localQuantity: newQuantityId
      },
      expanded: false,
      customQuantity: isCustomQtyValid ? this.state.customQuantity : ''
    });
  };

  handleFromUpdate = (event, selectedFrom, key) => {
    let newDosageId, newQuantityId;
    const { localBrand, localForm, localDosage, localQuantity } =
      this.state.localDrug;
    let { dosage, displayQuantity } =
      this.props.brandTypes[localBrand].formTypes[localForm].dosage[localDosage]
        .quantities[localQuantity];
    event.stopPropagation();
    newDosageId = _.findConsolidatedDosageIndex(
      this.props.brandTypes[localBrand].formTypes[key].dosage,
      dosage
    );
    newQuantityId = _.findConsolidatedQuantityIndex(
      this.props.brandTypes[localBrand].formTypes[key].dosage[newDosageId]
        .quantities,
      displayQuantity
    );

    let isCustomQtyValid = false;
    if (!_.isEmpty(this.state.customQuantity))
      isCustomQtyValid = _.checkIfCustomQtyVisible(
        this.props.brandTypes[localBrand].formTypes[key].name
      );

    this.setState({
      localDrug: {
        localBrand: localBrand,
        localForm: key,
        localDosage: newDosageId,
        localQuantity: newQuantityId
      },
      expanded: false,
      customQuantity: isCustomQtyValid ? this.state.customQuantity : ''
    });
  };

  handleDosageUpdate = (event, selectedDosage, key) => {
    let newQuantityId;
    const { localBrand, localForm, localDosage, localQuantity } =
      this.state.localDrug;
    let { displayQuantity, form } =
      this.props.brandTypes[localBrand].formTypes[localForm].dosage[localDosage]
        .quantities[localQuantity];
    event.stopPropagation();
    newQuantityId = _.findConsolidatedQuantityIndex(
      this.props.brandTypes[localBrand].formTypes[localForm].dosage[key]
        .quantities,
      displayQuantity
    );
    this.setState({
      localDrug: {
        localBrand: localBrand,
        localForm: localForm,
        localDosage: key,
        localQuantity: newQuantityId
      },
      expanded: false,
      customQuantity:
        !_.isEmpty(this.state.customQuantity) && _.checkIfCustomQtyVisible(form)
          ? this.state.customQuantity
          : ''
    });
  };

  handleQuantityUpdate = (event, quantity, key) => {
    const { localBrand, localForm, localDosage } = this.state.localDrug;
    event.stopPropagation();
    this.setState({
      localDrug: {
        localBrand: localBrand,
        localForm: localForm,
        localDosage: localDosage,
        localQuantity: key
      },
      expanded: false,
      customQuantity: ''
    });
  };

  handleCustomQuantityUpdate = quantity => {
    this.setState({ customQuantity: quantity });
  };

  handleCustomQuantityFocus = () => {
    this.setState({
      expanded: false
    });
  };

  // if user clicks on see all prices then only update the drug filter.

  handleSaveClick = () => {
    const { localBrand, localForm, localDosage, localQuantity } =
      this.state.localDrug;
    const newState = {
      brandId: localBrand,
      formId: localForm,
      dosageId: localDosage,
      quantityId: localQuantity
    };
    const quantityObj =
      this.props.brandTypes[newState.brandId].formTypes[newState.formId].dosage[
        newState.dosageId
      ].quantities[newState.quantityId];
    // sending ndc and quantity and customQuantity back to parent component
    const finalQty = !_.isEmpty(this.state.customQuantity)
      ? this.state.customQuantity
      : quantityObj.quantity;
    this.props.handleEditSuccess(
      finalQty,
      !_.isEmpty(this.state.customQuantity),
      quantityObj
    );
  };

  renderForms(Forms) {
    if (Forms && Forms.length > 0) {
      return Forms.map((item, key) => (
        <label
          key={key}
          className={`sc-form-radio themeFocus ${
            key === this.state.localDrug.localForm
              ? 'sc-form__radio selected themeFocus'
              : 'sc-form__radio sc-form__radio-nonbrand-circle themeFocus'
          }`}
          onClick={event => this.handleFromUpdate(event, item.name, key)}
          tabIndex="0"
        >
          <input
            name="Form"
            type="radio"
            defaultValue="Bottle"
            className="sc-form__radio--input sc-form__rx-form themeFocus"
            onClick={event => this.handleFromUpdate(event, item.name, key)}
            tabIndex="0"
          />
          <span className="sc-form__radio--check hidden" />
          <span className="sc-form__radio--label">{item.name}</span>
        </label>
      ));
    } else return [];
  }

  renderDosages(dosages) {
    if (dosages && dosages.length > 0) {
      return dosages.map((item, key) => (
        <label
          key={key}
          className={` sc-form__radio themeFocus
            ${
              key === this.state.localDrug.localDosage
                ? 'sc-form__radio selected themeFocus'
                : 'sc-form__radio sc-form__radio-nonbrand-circle themeFocus'
            }`}
          tabIndex="0"
        >
          <input
            name="Dosage"
            type="radio"
            defaultValue="10MG"
            className="sc-form__radio--input sc-form__rx-dosage"
            onClick={event => this.handleDosageUpdate(event, item.dosage, key)}
          />
          <span className="sc-form__radio--check hidden" />
          <span className="sc-form__radio--label">
            {item.dosage.toLowerCase()}
          </span>
        </label>
      ));
    } else return [];
  }

  renderQuantityOptions(quntities) {
    if (quntities && quntities.length > 0) {
      return quntities.map((item, key) => (
        <label
          key={key}
          className={
            this.state.localDrug.localQuantity === key &&
            _.isEmpty(this.state.customQuantity)
              ? 'dialogComponent mobileDialog sc-form__radio selected themeFocus'
              : 'dialogComponent mobileDialog sc-form__radio sc-form__radio-nonbrand-circle themeFocus'
          }
          tabIndex="0"
          onKeyPress={event =>
            this.renderQuantityKeyListener(event, item.displayQuantity, key)
          }
          onClick={event =>
            this.handleQuantityUpdate(event, item.displayQuantity, key)
          }
        >
          <span>{item.displayQuantity}</span>
        </label>
      ));
    } else return [];
  }

  renderQuantity(quntities) {
    if (quntities && quntities.length > 0) {
      return quntities.map((item, key) => (
        <label
          key={key}
          className={`sc-form__radio themeFocus ${
            this.state.localDrug.localQuantity === key &&
            _.isEmpty(this.state.customQuantity)
              ? 'selected'
              : 'sc-form__radio-nonbrand-circle'
          }`}
          tabIndex="0"
        >
          <input
            name="Quantity"
            type="radio"
            defaultValue="7"
            className="sc-form__radio--input sc-form__rx-qty themeFocus"
            onClick={event =>
              this.handleQuantityUpdate(event, item.displayQuantity, key)
            }
            tabIndex="0"
          />
          <span className="sc-form__radio--check hidden" />
          <span className="sc-form__radio--label">{item.displayQuantity}</span>
        </label>
      ));
    } else return [];
  }

  // eslint-disable-next-line
  componentWillReceiveProps(newProps) {
    if (!_.isEqual(newProps.drugIds, this.props.drugIds)) {
      this.setState({
        localDrug: {
          localBrand: newProps.drugIds.brandId,
          localForm: newProps.drugIds.formId,
          localDosage: newProps.drugIds.dosageId,
          localQuantity: newProps.drugIds.quantityId
        }
      });
    }
    if (!_.isEqual(newProps.customQuantity, this.props.customQuantity)) {
      this.setState({
        customQuantity: newProps.customQuantity
      });
    }
  }

  render() {
    const { classes, showModal, brandTypes, t } = this.props;
    const { localBrand, localForm, localDosage, localQuantity } =
      this.state.localDrug;
    const { expanded } = this.state;
    const formTypes = brandTypes[localBrand].formTypes;
    const { dosage, name: formName } = formTypes[localForm];
    const { quantities, dosage: dosageName } = dosage[localDosage];
    const brandList = this.renderBrands(this.props.brandTypes, localBrand);
    const fromList = this.renderForms(formTypes, localForm);
    const dosageList = this.renderDosages(dosage, localDosage);
    const qtyList = this.renderQuantityOptions(quantities, localQuantity);
    const selectedBrand = this.props.brandTypes.filter(
      (item, key) => key === this.state.localDrug.localBrand
    );
    return (
      <div
        aria-labelledby="contact-modal"
        aria-describedby="contact-modal"
        open={showModal}
        className={`editDosageModal newDosageModal saveDrugModal`}
      >
        <div className="modal-edit">
          <div className="modal-body filter-content modal-rx-filter--content">
            <div
              className={`rx-filters-main brands ${
                !_.isEmpty(brandTypes) &&
                brandTypes.length === 1 &&
                'disabledDiv'
              }`}
            >
              <p className={`${classes.heading} rx-filters-row--header`}>
                <span className="activeLink">{t('Brand')}</span>
              </p>
              <div
                onClick={() => this.handleChange('panel1')}
                className={`rx-filters-row rx-filters--type themeFocus ${
                  expanded === 'panel1' && 'activeList'
                }`}
                tabIndex="0"
              >
                <p
                  className={`${classes.secondaryHeading} drug-pricing--filters drug-pricing--filters-type drug-pricing--filters-mobile-dd`}
                >
                  {selectedBrand[0].brand} (
                  {selectedBrand[0]?.drugType
                    ? selectedBrand[0]?.drugType
                    : selectedBrand[0].isGeneric
                    ? `${t('Generic')}`
                    : `${t('Brand')}`}
                  )
                </p>
                <span
                  className={`downArrow downArrowTop ${
                    expanded === 'panel1' && 'upArrow'
                  }`}
                >
                  <LazyLoadImage
                    src="/content/images/icons/downArrowGray.svg"
                    height="24"
                    width="24"
                    alt=""
                  />
                </span>
              </div>
              <div
                className={`rx-filters-list-pd ${
                  expanded !== 'panel1' && 'hideMe'
                }`}
              >
                <div className="rx-filters--list rx-filters--list-dosages">
                  {brandList}
                </div>
              </div>
            </div>
            <div
              className={`rx-filters-main ${
                !_.isEmpty(formTypes) && formTypes.length === 1 && 'disabledDiv'
              }`}
              onClick={() => this.handleChange('panel2')}
            >
              <div className="rx-filters-row rx-filters--form">
                <p className={`${classes.heading} rx-filters-row--header`}>
                  <span className="activeLink">{t('Form')}</span>
                </p>
              </div>
              <div className="rx-filters-list-pd">
                <div>
                  <div className="rx-filters--list rx-filters--list-form">
                    {fromList}
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`rx-filters-main list-dosage ${
                !_.isEmpty(dosage) && dosage.length === 1 && 'disabledDiv'
              }`}
            >
              <p className={`${classes.heading} rx-filters-row--header`}>
                <span className="activeLink">{t('Dosage')}</span>
              </p>
              <div
                onClick={() => this.handleChange('panel3')}
                className={`rx-filters-row rx-filters--form themeFocus ${
                  expanded === 'panel3' && 'activeList'
                }`}
                tabIndex="0"
              >
                <div>
                  <p
                    className={`${classes.secondaryHeading} drug-pricing--filters drug-pricing--filters-type drug-pricing--filters-mobile-dd`}
                  >
                    {_.toLower(dosageName)}
                  </p>
                  <span
                    className={`downArrow downArrowTop ${
                      expanded === 'panel3' && 'upArrow'
                    }`}
                  >
                    <LazyLoadImage
                      src="/content/images/icons/downArrowGray.svg"
                      height="24"
                      width="24"
                      alt=""
                    />
                  </span>
                </div>
                <div
                  className={`rx-filters-list-pd ${
                    expanded !== 'panel3' && 'hideMe'
                  }`}
                >
                  <div>
                    <div className="rx-filters--list rx-filters--list-dosage rx-filters--list-split">
                      {dosageList}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="quantityWrapper">
              <div
                className={`rx-filters-main list-dosage quantityLists ${
                  !_.isEmpty(qtyList) && qtyList.length === 1 && 'disabledDiv'
                } ${_.checkIfCustomQtyVisible(formName) && 'noneCustomQty'}`}
              >
                <p className={`${classes.heading} rx-filters-row--header`}>
                  <span className="activeLink">{t('Quantity')}</span>
                </p>
                <div
                  onClick={() => this.handleChange('panel4')}
                  className={`dialogComponent mobileDialog rx-filters-row rx-filters--form themeFocus ${
                    expanded === 'panel4' && 'activeList'
                  }`}
                  tabIndex="0"
                  onKeyDown={event => {
                    if (event.key === 'Enter') {
                      this.handleChange('panel4');
                    }
                  }}
                >
                  <div>
                    <p
                      className={`drug-pricing--filters drug-pricing--filters-type drug-pricing--filters-mobile-dd`}
                    >
                      {this.state.customQuantity
                        ? '-'
                        : quantities[this.state.localDrug.localQuantity]
                            ?.displayQuantity}
                    </p>
                    <span
                      className={`downArrow ${
                        expanded === 'panel4' && 'upArrow'
                      }`}
                    >
                      <LazyLoadImage
                        src="/content/images/icons/downArrowGray.svg"
                        height="24"
                        width="24"
                        alt=""
                      />
                    </span>
                  </div>

                  <div
                    className={`rx-filters-list-pd ${
                      expanded !== 'panel4' && 'hideMe'
                    }`}
                  >
                    <div>
                      <div className="rx-filters--list rx-filters--list-dosage rx-filters--list-split">
                        {expanded === 'panel4' && qtyList}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {_.checkIfCustomQtyVisible(formName) && (
                <div className="qtyMiddleLabel">
                  <span>or</span>
                </div>
              )}

              {_.checkIfCustomQtyVisible(formName) &&
                !_.isUndefined(this.state.customQuantity) && (
                  <CustomQuantity
                    isFromSavedDrugs={true}
                    quantity={this.state.customQuantity}
                    handleCustomQuantityUpdate={this.handleCustomQuantityUpdate}
                    handleFocus={this.handleCustomQuantityFocus}
                  />
                )}
            </div>
            <button
              className="sc-btn-pink themeFocus gradientPink"
              onClick={this.handleSaveClick}
              tabIndex="0"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DropdownSelection.defaultProps = {
  showModal: false,
  toggleModal: () => {},
  classes: { paper: '' }
};

DropdownSelection.propTypes = {
  showModal: bool,
  toggleModal: func,
  classes: any,
  handleBrandSelect: func,
  handleBrandChange: func,
  handleFormUpdate: func,
  handleDosageUpdate: func,
  handleQuantityUpdateMobile: func,
  defaultStructure: any,
  dosageData: any,
  dosageId: any,
  brandId: any,
  quantityId: any,
  formId: any,
  brand: any,
  form: any,
  dosage: any,
  quantity: any,
  brandTypes: any,
  formTypes: any,
  drugIds: any,
  updateDosage: func,
  customQuantity: string,
  handleMobilePricing: func
};

export default withTranslation()(DropdownSelection);
